(function () {

    "use strict";

    angular.module('harriApp')
        .controller("AddNoteToCandidatesModal", AddNoteToCandidatesModalController);

    AddNoteToCandidatesModalController.$inject = ['$scope', 'modalData'];

    function AddNoteToCandidatesModalController($scope, modalData) {
        var self = this;
        self.activeBrand = modalData.activeBrand;
        self.sourceBrand = modalData.sourceBrand;
        self.candidates = modalData.candidates || [];
        self.invalidCandidates = false;

        self.selectedCandidates = angular.copy(self.candidates);

        self.close = function () {
            $scope.$hide();
        };

        self.onSelectedCandidatesChanged = function () {
            self.invalidCandidates = !(self.selectedCandidates && self.selectedCandidates.length);
            self.selectedCandidatesIds = _.pluck(self.selectedCandidates, "id");
        };

        self.onNoteAdded = function (data) {
            self.close();
        };

        self.onSelectedCandidatesChanged();
    }

})();